import { render, staticRenderFns } from "./planDetails.vue?vue&type=template&id=738a3371&scoped=true"
import script from "./planDetails.vue?vue&type=script&lang=js"
export * from "./planDetails.vue?vue&type=script&lang=js"
import style0 from "./planDetails.vue?vue&type=style&index=0&id=738a3371&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738a3371",
  null
  
)

export default component.exports